import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import useClientTabMissingFields from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/useClientTabMissingFields'

const ResidenceType = () => {
  const { residenceOptionsArray, showResidenceType, updateAddress, errors, t, residenceType, optionalResidenceFields } =
    useAddress()
  const isMissing = useClientTabMissingFields()

  if (!showResidenceType) {
    return null
  }

  return (
    <SDFormControl
      plainLabel
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.residence_type'),
          }}
        />
      )}
      error={getError('residenceType', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddress({ residenceType: value })
        }}
        options={residenceOptionsArray}
        selectedValue={residenceType}
        missing={isMissing('residenceType')}
        newTranslations={true}
        translationsPath='subscriptionForm:address_module.residence_types.'
      />
    </SDFormControl>
  )
}

export default ResidenceType
